import "core-js/modules/es6.array.find";
import "core-js/modules/es6.function.name";
import router from "./router";
import { getOperateAuth } from '@/config/operateAuth';

// 登录相关信息
var authHash = {};
var menuHash = {};
var activePath = ""; // 第一个有权访问的路径
var _getMenuInfo = function getMenuInfo(routes, pRoute) {
  if (!Array.isArray(routes) || routes.length < 1) return false;
  routes.map(function (route) {
    var path = route.path,
      name = route.name,
      _route$meta = route.meta,
      meta = _route$meta === void 0 ? {} : _route$meta,
      _route$children = route.children,
      children = _route$children === void 0 ? [] : _route$children;
    var auths = meta.auths;
    var list, limit;
    if (Array.isArray(auths)) {
      list = auths;
      limit = 'every';
    } else {
      auths = auths || {};
      list = auths.list || [];
      limit = auths.limit || 'every';
    }
    if (!getOperateAuth(list, limit, authHash)) return true;
    var copy = {
      path: path,
      name: name,
      meta: meta,
      children: [],
      redirect: '',
      pName: ''
    };
    var pName;
    if (pRoute) {
      pName = pRoute.name;
      copy.pName = pName;
      if (!pRoute.redirect) {
        pRoute.redirect = path;
      }
      pRoute.children.push(copy);
    }
    menuHash[name] = copy;
    if (!activePath) activePath = path;
    _getMenuInfo(children, copy);
  });
};
var getLoginInfo = function getLoginInfo(user) {
  var authList = user.group.permissions || [];
  authList.map(function (item) {
    authHash[item.codename] = true;
  });
  var routes = router.options.routes;
  var rootMenuRoute = routes.find(function (item) {
    return item.name === 'Module';
  });
  _getMenuInfo([rootMenuRoute]);
  return {
    authHash: authHash,
    menuHash: menuHash,
    activePath: activePath
  };
};
export default {
  getLoginInfo: getLoginInfo
};